module.exports = __webpack_public_path__ + "static/contact-c74868b90c4221759183c30a5370c887.jpg";